import util from '@/utils/index'
export const user = {
    data() {
        return {
            isLoginend: false
        };
    },
    computed: {
        // 用于校验用户信息
        userInfo() {
            return this.$store.state.userInfo;
        },
        // 用于显示使用用户信息
        userData() {
            return this.$store.getters.userInfo;
        },
        /* 用于子页面判断是否登录,子页面需加入以下配置
           props: {
             isLogin: {
                type: Boolean,
                default: false
            }
        }, */
        isAutoLogin() {
            return this.isLogin;
        }
    },
    created() {
        // 页面创建时判断是否已经获取到用户信息
        if (this.userInfo) {
            // console.log('created')
            // 限流函数避免频繁触发
            util.limiting(this.userInfoChange)
        }
    },
    watch: {
        // 用于刷新页面时监听用户信息的变化
        // 如果页面是从其他页面进入,此时userInfo固定不会触发监听,那么在created中做判断即可
        // 如果是刷新页面,userInfo初始为null,自动登录后userInfo发生变化就能监听到了
        userInfo(v) {
            if (v) {
                // 限流函数避免频繁触发
                util.limiting(this.userInfoChange)
            }
        },
        // 用于子页面判断是否登录
        isAutoLogin: {
            handler(v) {
                if (v) {
                    this.itemUserLoginend && this.itemUserLoginend();
                }
            },
            immediate: true
        }
    },
    methods: {
        userInfoChange() {
            const me = this;
            me.isLoginend = true;
            me.userLoginend && me.userLoginend();
        },
        // 刷新用户信息
        refreshUser() {
            // 获取用户信息
            this.$store.dispatch("userInfo", true);
        },
        // 刷新用户信息与兑换信息
        refreshMoney() {
            this.$store.dispatch("money/verificationInfo", true);
            // 获取最新提现状态
            this.$store.dispatch("money/moneyRecord", true);
            this.refreshUser();
        }
    }
}